module.exports = __webpack_public_path__ + "static/media/TV.42565ccc.svg";